import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import GeneratorToolCard from '../components/GeneratorToolCard.vue'
import { Context, RolesService, UsersService, mockUser, throwObjectNotFound, User } from '@prodcard/core'
import { GeneratorTool, getRandomFromRepo, getRandomItem } from '../components/model'

const SUPERADMIN_USER_ID = 'b369ab0f3db648d2b12c4ce7afcbb6ca'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTool',
  props: {
    usersService: {},
    rolesService: {}
  },
  setup(__props: any) {

const props = __props;



async function getRandomRoleId(ctx: Context) {
  return getRandomItem(await props.rolesService.findAll(ctx))?.id ?? throwObjectNotFound('<c239ae5c>')
}

async function getRandomUser(ctx: Context): Promise<User | undefined> {
  const user = await getRandomFromRepo(paging => props.usersService.findAll(ctx, { paging }))
  return user?.id === SUPERADMIN_USER_ID ? undefined : user
}

const generatorTool: GeneratorTool = {
  create: async (ctx: Context) => {
    const salesPoint = mockUser()
    await props.usersService.add(ctx, {
      ...salesPoint,
      password: '123',
      roleId: await getRandomRoleId(ctx),
      municipalEntityId: undefined,
      controlQuestionId: undefined,
      controlAnswer: undefined,
      cardIssuePointId: undefined,
    })
  },
  update: async (ctx: Context) => {
    const sp = await getRandomUser(ctx)
    if (!sp) return
    const salesPoint = mockUser()
    await props.usersService.update(ctx, sp.id, {
      ...salesPoint,
      roleId: await getRandomRoleId(ctx),
      municipalEntityId: undefined,
      controlQuestionId: undefined,
      controlAnswer: undefined,
      cardIssuePointId: undefined,
    })
  },
  delete: async (ctx: Context) => {
    const sp = await getRandomUser(ctx)
    if (!sp) return
    await props.usersService.delete(ctx, sp.id)
  },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneratorToolCard, {
    title: "Действия с пользователями",
    "generator-tool": generatorTool
  }))
}
}

})